"use client";
import { useAssets } from "@/lib/utils";
import React, { useState, useEffect } from "react";

import Image from "next/image";
import { useTranslations } from "next-intl";

export default function Table() {
  const t = useTranslations("UpdateHargaAyam");
  // helper
  const assets = useAssets();
  const fixDate = (date: string | number | Date) => {
    return new Date(date).toLocaleDateString("id-ID", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // data for row
  const [dataDefault, setDataDefault] = useState<any[] | null>(null);
  const [data, setData] = useState<any[] | null>(null);
  const [dataS, setDataS] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const url = process.env.NEXT_PUBLIC_HARGA_API as string;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const dataq = await response.json();
        setDataDefault(dataq);
        setData(dataq);
        setDataS(dataq[0]);
      } catch (error) {
        throw new Error(`Undefined error! : ${error}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData().catch((e) => {
      // handle the error as needed
      console.error("An error occurred while fetching the data: ", e);
    });
  }, []);

  const [provinceFilter, setProvinceFilter] = useState("");
  useEffect(() => {
    if (dataDefault) {
      console.log(dataDefault);
      const filteredData =
        provinceFilter.trim() === ""
          ? dataDefault
          : dataDefault.filter((row) =>
              row.city.toLowerCase().includes(provinceFilter.toLowerCase())
            );
      setData(filteredData);
      console.log(filteredData);
    }
  }, [provinceFilter]);

  const handleProvinceFilterChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (data) {
      const q = {
        bottom_price: 23500,
        city: "Bali",
        date: "2024-04-07T00:00:00.000Z",
        top_price: 24000,
        trend: "Stag",
        updated_at: "2024-04-08T08:00:11.092Z",
      };
      const value = event.target.value;
      setProvinceFilter(event.target.value);
    }
  };

  return (
    <section className="bx-container mb-20">
      <div className="flex justify-between items-end flex-wrap mb-6">
        <div className="bg-[#FEF8E2] w-[290px] p-4">
          <h6 className="text-md">{t("updateLabel")}:</h6>
          <p className="text-lg font-semibold mt-2">
            {dataS ? fixDate(dataS["updated_at"]) : "..."}
          </p>
        </div>
        <form onSubmit={(e) => e?.preventDefault?.()}>
          <label
            htmlFor="default-search"
            className="mb-2 text-sm font-medium text-gray-900 sr-only "
          >
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-500 "
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
              placeholder={t("searchLabel")}
              required
              value={provinceFilter}
              onChange={handleProvinceFilterChange}
            />
          </div>
        </form>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#EAECF0] border-y-2">
              <th className="text-[#667085] text-left px-4 py-2">
                {t("tableColumns.region")}
              </th>
              <th className="text-[#667085] text-left px-4 py-2">
                {t("tableColumns.hargaTerendah")}
              </th>
              <th className="text-[#667085] text-left px-4 py-2">
                {t("tableColumns.hargaTertinggi")}
              </th>
              <th className="text-[#667085] text-left px-4 py-2">
                {t("tableColumns.tren")}
              </th>
              <th className="text-[#667085] text-left px-4 py-2">
                {t("tableColumns.tanggal")}
              </th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr className="border-y-2">
                <td
                  colSpan={12}
                  className="px-4 py-2 text-center text-slate-400"
                >
                  {t("tableLoadingText")}
                </td>
              </tr>
            )}
            {/* ITEM 1 */}
            {/* {data ? ( */}
            {data &&
              data.map(
                (
                  item: {
                    city: String;
                    bottom_price: String;
                    top_price: String;
                    trend: String;
                    date: string | number | Date;
                  },
                  i
                ) => (
                  <tr key={i} className="border-y-2">
                    <td className="px-4 py-2">{item.city}</td>
                    <td className="px-4 py-2">
                      {" "}
                      {item.bottom_price.toLocaleString()}
                    </td>
                    <td className="px-4 py-2">
                      {item.top_price.toLocaleString()}
                    </td>
                    <td className="px-4 py-2">
                      {/* {item.trend} */}
                      {item.trend == "Stag-Naik" && (
                        <Image
                          src={assets.stagNaik}
                          width={30}
                          height={30}
                          alt="BroilerX logo"
                        />
                      )}
                      {item.trend == "Stag" && (
                        <Image
                          src={assets.stag}
                          width={30}
                          height={30}
                          alt="BroilerX logo"
                        />
                      )}
                      {item.trend == "Stag-Turun" && (
                        <Image
                          src={assets.stagTurun}
                          width={30}
                          height={30}
                          alt="BroilerX logo"
                        />
                      )}
                      {item.trend == "Naik" && (
                        <Image
                          src={assets.naik}
                          width={30}
                          height={30}
                          alt="BroilerX logo"
                        />
                      )}
                      {item.trend == "Turun" && (
                        <Image
                          src={assets.turun}
                          width={30}
                          height={30}
                          alt="BroilerX logo"
                        />
                      )}
                    </td>
                    <td className="px-4 py-2">{fixDate(item.date)}</td>
                  </tr>
                )
              )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
